export const CHART_COLORS = {
  primary: '#ef4444',
  secondary: '#2563eb',
  sum: '#059669',
  sumFill: 'rgba(5,150,105,.08)',
  june: '#f59e0b',
  december: '#94a3b8',
};
